import React, { Component } from 'react'
import axios from 'axios'
import { Dropdown, Button, Icon } from '@softwaredev_cegeka/stix-core'
import { AxiosSelect } from '@softwaredev_cegeka/stix-form-select'
import { UserDataContext } from 'src/components/auth/withAuth'

class ImpersonateUserMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            userData: {},
            users: [],
        }
    }

    static contextType = UserDataContext

    /**
     * Divides user search terms into 2 parts for first and last name.
     * @param input
     * @returns {{part1: string, part2: string}}
     */
    splitSearch(input) {
        const [part1, ...parts] = input.trim().split(' ')
        // We use an OR search endpoint, and need to provide the same input for part 2, if the search doesn't exist out
        // of multiple space separated names. This way we can also search last names containing the search param.
        return { part1, part2: parts.length > 0 ? parts.join(' ') : part1 }
    }

    renderUserMenuOption = response => {
        this.setState({ loading: true })
        return response.data.results.map(user => ({
            id: user.id.toString(),
            value: user.username,
            label: `${user.first_name} ${user.last_name}`,
        }))
    }

    handleUserChange = async chosen => {
        if (!chosen) {
            //Stop impersonating
            try {
                axios.delete('/api/auth/impersonator').then(response => {
                    const data = {
                        is_global_admin: response.data.global_admin,
                        firstName: response.data.first_name,
                        lastName: response.data.last_name,
                        is_local_user: false,
                        username: response.data.username,
                        email: response.data.email,
                    }
                    let permissions = null
                    this.getPermissions(data.username, null, {
                        Authorization: response.headers.authorization,
                    }).then(permissionResponse => {
                        const { app_permissions } = permissionResponse.data
                        if (!app_permissions || app_permissions.length === 0) {
                            permissions = []
                        } else {
                            permissions = app_permissions[0].actions
                        }
                        this.context.setImpersonatedUser(
                            response.headers.authorization,
                            null,
                            data,
                            null,
                            permissions
                        )
                    })
                })
            } catch (e) {
                console.error(e)
            }
        } else {
            // Impersonate user
            try {
                axios
                    .post('/api/auth/impersonator', {
                        sub: chosen.value,
                    })
                    .then(response => {
                        const data = {
                            is_global_admin: response.data.global_admin,
                            firstName: response.data.first_name,
                            lastName: response.data.last_name,
                            is_local_user: false,
                            username: response.data.username,
                            email: response.data.email,
                        }
                        let permissions = null
                        this.getPermissions(chosen.value, null).then(
                            permissionResponse => {
                                const { app_permissions } =
                                    permissionResponse.data
                                if (
                                    !app_permissions ||
                                    app_permissions.length === 0
                                ) {
                                    permissions = []
                                } else {
                                    permissions = app_permissions[0].actions
                                }
                                this.context.setImpersonatedUser(
                                    response.headers.authorization,
                                    chosen,
                                    data,
                                    null,
                                    permissions
                                )
                            }
                        )
                    })
            } catch (e) {
                console.error(e)
            }
        }
    }

    getPermissions(username, organization, headers = {}) {
        try {
            let params = {}
            if (organization) {
                params.organization_id = organization
            }
            return axios.get(`/api/auth/users/${username}/app-permissions`, {
                params,
                headers: { ...axios.defaults.headers, ...headers },
            })
        } catch (e) {
            console.error(e)
        }
    }

    renderUserImpersonate() {
        if (this.context.impersonatedUser) {
            return (
                <>
                    <Dropdown.Header>Impersonate</Dropdown.Header>
                    <div className={'impersonate-active'}>
                        <p>
                            You are impersonating{' '}
                            {this.context.impersonatedUser.label}.
                        </p>
                        <Button
                            variant={'naked'}
                            onClick={() => this.handleUserChange(null)}
                        >
                            <Icon icon={'close'} />
                        </Button>
                    </div>
                </>
            )
        }

        if (!this.context.data?.is_global_admin) {
            return null
        }

        return (
            <>
                <Dropdown.Header>Impersonate</Dropdown.Header>
                <AxiosSelect
                    apiConfig={{
                        url: '/api/auth/users',
                        params: input => {
                            const { part1, part2 } = this.splitSearch(input)
                            return {
                                first_name_like: part1,
                                last_name_like: part2,
                                use_or: true,
                                per_page: 20,
                                sort: '+username',
                            }
                        },
                    }}
                    itemRenderer={this.renderUserMenuOption}
                    label={'Search user'}
                    srOnly
                    isSearchable
                    isClearable
                    menuIsOpen
                    onChange={this.handleUserChange}
                    value={this.context.impersonatedUser}
                    placeholder={'Search users'}
                />
            </>
        )
    }

    render() {
        const { userData } = this.state
        return !userData.is_local_user ? (
            <>{this.renderUserImpersonate()}</>
        ) : null
    }
}

export default ImpersonateUserMenu
